import * as React from 'react'

import {
  InitialParentSignUpForm,
  InitialParentSignUpFormSSO,
} from 'main/components/common/AuthModal'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { UserSignUpSource } from 'main/util/user'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../../../common'
import { i18nKeyPrefix } from '../../../../../../i18n'

import { ICoreProps, IExtraProps, StepType } from '../types'
import { SignUpContainer, StyledText } from './SignUp.styles'

const PRE = `${i18nKeyPrefix}-CTA-ENROLL-STEPS-SIGNUP`

export default function SignUp(props: ICoreProps & IExtraProps) {
  const { school, onAuth, changeStep } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  if (isSSO) {
    return (
      <SignUpContainer>
        <InitialParentSignUpFormSSO
          source={UserSignUpSource.ParentInstantEnrollModal}
          segmentData={{
            event: 'New Parent Lead',
            data: { schoolId: school.id },
          }}
        />
      </SignUpContainer>
    )
  } else {
    return (
      <SignUpContainer>
        <StyledText>{t(`${PRE}-TEXT`)}</StyledText>

        <InitialParentSignUpForm
          cta="Sign up"
          source={UserSignUpSource.ParentInstantEnrollModal}
          trackingData={{ schoolId: school.id }}
          onComplete={credentials => {
            onAuth(credentials)
            changeStep()
          }}
          onRequestLogin={() => changeStep(StepType.LOGIN)}
        />
      </SignUpContainer>
    )
  }
}
